import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import responsiveText from 'ui/styles/responsiveText'
import Button from 'ui/components/generic/Button'

export default class FocusDonate extends Component {
  render() {
    const {
      title,
      text,
      link,
      external,
    } = this.props

    console.log(this.props)

    return(
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={10}
              smOffset={1}
            >
              <FocusContainer>
                <TextContainer>
                  <Title>{title}</Title>
                  <Text>{text}</Text>
                </TextContainer>
                {link.url && link.title &&
                  <ButtonContainer>
                    <Button
                      title={link.title}
                      link={link.url}
                      target={link.target}
                      external={external}
                      look="orange"
                    />
                  </ButtonContainer>
                }
              </FocusContainer>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 120px;
`

const FocusContainer = styled.div`
  background: ${props => props.theme.colors.primary};
  padding: 40px 0;

  ${media.lg`
    padding: 90px 0;
  `}
`

const TextContainer = styled.div`
  margin-left: calc(10% + ${props => props.theme.grid.col.padding / 2}px - ${props => props.theme.grid.row.padding}px);
  color: white;

  ${media.xs`
    margin: 0 25px;
    max-width: 100%;
  `}

  ${media.sm`
    margin: 0 35px;
    max-width: 100%;
  `}

  ${media.lg`
    margin: 0 140px 0 70px;
  `}

  ${media.xl`
    max-width: 65%;
    margin: 0 140px 0 100px;
  `}
`

const Title = styled.h2`
  ${responsiveText('md')};

`

const Text = styled.p``

const ButtonContainer = styled.div`
  position: absolute;
  right: ${props => props.theme.grid.col.padding}px;
  bottom: 0;
  transform: translateY(50%);
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/FocusDonate/index.js